import { NgModule } from '@angular/core';
import { MeetingModule } from '@business/meeting/meeting.module';
import { Ms365Module } from '@business/ms365/ms365.module';
import { PresenceModule } from '@business/presence/presence.module';
import { ProductOptionModule } from '@business/product-option/product-option.module';
import { SystemModule } from '@business/system/system.module';

/**
 * This module imports modules that are required but are not being used
 * by a route definition (e.g. if there are multiple routing modules
 * because the components are being used on multiple menu levels,
 * then the module itself is never imported by a route definition).
 */
@NgModule({
  declarations: [],
  imports: [SystemModule, ProductOptionModule, PresenceModule, Ms365Module, MeetingModule],
})
export class BusinessModule {}
